import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { Tooltip } from '@mui/material';
import PropTypes from 'prop-types';

const formatCount = (value) => value.toLocaleString();

const getParticipationCount = (analytics) => analytics?.rows?.[0]?.distinct_clinic_count || 0;

function ParticipationKpi({ analytics }) {
    const participationCount = getParticipationCount(analytics);
    const hasData = (analytics?.rows || []).length > 0;

    return (
        <section className="dashboard-kpi-card">
            <div className="dashboard-chart-header dashboard-chart-header--with-icon">
                <h2>Participation</h2>
                <Tooltip title="The number of clinics contributing at least one scan in the selected date range.">
                    <InfoOutlinedIcon className="dashboard-chart-info-icon" fontSize="small" />
                </Tooltip>
            </div>
            <div className="dashboard-kpi-card__body">
                {hasData ? (
                    <>
                        <div className="dashboard-kpi-card__value">
                            {formatCount(participationCount)}
                        </div>
                        <div className="dashboard-kpi-card__label">Active Clinics</div>
                    </>
                ) : (
                    <div className="dashboard-kpi-card__empty">No data</div>
                )}
            </div>
        </section>
    );
}

ParticipationKpi.propTypes = {
    analytics: PropTypes.shape({
        rows: PropTypes.arrayOf(PropTypes.shape({
            distinct_clinic_count: PropTypes.number,
        })),
    }),
};

ParticipationKpi.defaultProps = {
    analytics: null,
};

export default ParticipationKpi;
